import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'danger',
  WARNING = 'warning',
  INFO = 'info'
}

export interface Notification {
  id: number;
  type: NotificationType;
  message: string;
  autoClose?: boolean;
  keepAfterRouteChange?: boolean;
  timeout?: number;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private subject = new BehaviorSubject<Notification[]>([]);
  private idCounter = 0;

  onNotification(): Observable<Notification[]> {
    return this.subject.asObservable();
  }

  getNotifications(): Notification[] {
    return this.subject.value;
  }
  success(message: string, options: Partial<Notification> = {}): void {
    this.addNotification({
      ...options,
      type: NotificationType.SUCCESS,
      message
    });
  }

  error(message: string, options: Partial<Notification> = {}): void {
    this.addNotification({
      ...options,
      type: NotificationType.ERROR,
      message
    });
  }

  info(message: string, options: Partial<Notification> = {}): void {
    this.addNotification({
      ...options,
      type: NotificationType.INFO,
      message
    });
  }

  warning(message: string, options: Partial<Notification> = {}): void {
    this.addNotification({
      ...options,
      type: NotificationType.WARNING,
      message
    });
  }

  clear(id?: number): void {
    const notifications = this.subject.value || [];

    if (id) {
      // Remove a single notification
      this.subject.next(notifications.filter(notification => notification.id !== id));
    } else {
      // Clear all notifications
      this.subject.next([]);
    }
  }

  private addNotification(notification: Partial<Notification>): void {
    const id = ++this.idCounter;
    const fullNotification: Notification = {
      id,
      type: NotificationType.INFO,
      message: '',
      autoClose: true,
      keepAfterRouteChange: false,
      timeout: 5000,
      ...notification
    };

    const notifications = [...this.subject.value, fullNotification];
    this.subject.next(notifications);

    if (fullNotification.autoClose) {
      setTimeout(() => this.clear(id), fullNotification.timeout);
    }
  }
}
